import { zodResolver } from '@hookform/resolvers/zod';
import { useForm } from 'react-hook-form';

import { addressFormSchema, defaultAddressValues } from '../shared';

export function useFormDefinition(v = defaultAddressValues) {
  return useForm({
    resolver: zodResolver(addressFormSchema),
    defaultValues: v,
  });
}
